import { z } from 'zod'
import { BillingCode } from 'src/participantHistory/intakeNote/billingCodeConstants'

const MAX_INPUT_LENGTH = 3000

export const DISCHARGE_SUMMARY_NOTE_FORM_SCHEMA = z
  .object({
    date: z.string(),
    participant: z.object({
      firstName: z.string().min(1, 'First name is required'),
      lastName: z.string().min(1, 'Last name is required'),
      memberID: z.string().min(1, 'Kaiser MRN is required'),
    }),
    assessingPractitioner: z.object({
      name: z.string().min(1, 'Name is required'),
      licenseType: z.string().min(1, 'License type is required'),
    }),
    dischargeDate: z.string(),
    billingCodes: z.array(z.nativeEnum(BillingCode)).min(1, 'At least one billing code is required'),
    treatmentPlan: z
      .object({
        smartGoals: z.string().max(MAX_INPUT_LENGTH),
        goalsMet: z.enum(['yes', 'no']),
        details: z.string().max(MAX_INPUT_LENGTH).optional(),
      })
      .superRefine((data, ctx) => {
        const goalsNotMet = data.goalsMet === 'no'

        if (goalsNotMet) {
          if (!data.details || data.details.trim().length === 0) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: 'Required when goals are not met',
              path: ['details'],
            })
          }
        }
      }),
    reasonForDischarge: z.object({
      reason: z.enum(['programCompletion', 'earlyDisenrollment', 'voluntaryDisenrollment']),
      details: z.string().max(MAX_INPUT_LENGTH),
    }),
  })
  .required()

export type DischargeSummaryNoteFormType = z.infer<typeof DISCHARGE_SUMMARY_NOTE_FORM_SCHEMA>
